import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RemarksFormData as FormData } from "../../state/BookingCreateManager/RemarksFormData";

const updateFormData: Reducer<FormData> = (state: FormData = new FormData(), action: Action<ActionType, FormData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_FORM_UPDATED:
      return { ...state, ...action.data };
    case ActionType.BOOKING_CREATE_MANAGER_REMARKS_FORM_RESET:
      return new FormData();
    default:
      return state;
  }
};

export default updateFormData;